import { SuperDate, isValidObject } from '@razlet/utils';

export default class RaidHistory {
  date = null;

  userName = '';

  changes = [];

  dateFormatKeys = [
    'departureDateTime',
    'departureDateTimeUtc',
    'arrivalDateTime',
    'arrivalDateTimeUtc',
    'estimatedDepartureDateTime',
    'estimatedDepartureDateTimeUtc',
    'estimatedArrivalDateTime',
    'estimatedArrivalDateTimeUtc',
  ];

  booleanFormatKeys = [
    'saleClosed',
    'closed',
  ];

  flightsInfoKeys = [
    'status',
  ];

  constructor (data = {}) {
    if (!isValidObject(data)) return;

    this.date = new SuperDate(new Date(data.timestamp));
    this.userName = data.username;
    this.formatChanges(data.changes);
  }

  formatChanges (changes) {
    if (!changes) return;

    const changesKeys = Object.keys(changes);

    this.changes = changesKeys
      .filter(key => {
        const { prev, current } = changes[key];
        return !(prev == null && current == null);
      })
      .map(key => ({
        key,
        prev: this.#getChangeValue(key, changes[key].prev),
        current: this.#getChangeValue(key, changes[key].current),
        isDate: this.dateFormatKeys.includes(key),
        isBoolean: this.booleanFormatKeys.includes(key),
        isFlightsInfo: this.flightsInfoKeys.includes(key),
      }));
  }

#getChangeValue (key, value) {
    if (value === null || value === undefined) return null;
    if (this.dateFormatKeys.includes(key)) {
      return new SuperDate(new Date(value));
    }
    return value;
  }
};
